import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, Renderer2, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { CountryService } from '@teem/app/core/services/country.service';
import { DataLayerService } from '@teem/app/core/services/data-layer.service';
import { uniqueCustomerEmailValidator, uniqueCustomerPhoneValidator } from '@teem/app/core/utils/email-unique.validator';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { country as CountryApi } from "@teem/constants/api";
import { ProfileService } from '@teem/app/core/services/profile.service';
import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
declare var $;

@Component({
	selector: 'app-signup',
	templateUrl: './signup.component.html',
	styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
	@Output() authState = new EventEmitter<string>();
	signupForm: FormGroup;
	otpForm: FormGroup;
	step: number = 1;
	accountType: string = '';
	isTermsChecked: boolean = false;
	resendTimer: number = 0;
	resendDisabled: boolean = true;
	interval: any;
	selectedBusinessType: string = '';
	selectedFeature: string | null = null;
	countryListApi: string = CountryApi.signup;
	langAttribute: any = 'en';
	currentTab: 'email' | 'phone' = 'phone';
	showPassword = false;
	// countries: { id: number; calling_code: string; name: string }[] = [{ id: 248, calling_code: '358', name: 'Åland Islands'},{ id: 8, calling_code: '355', name: 'Albania'}];
	// countries: { id: number; calling_code: string; name: string }[] = [{ id: 248, calling_code: '358', name: 'Åland Islands'},{ id: 8, calling_code: '355', name: 'Albania'}];
	countries: any;
	selectedCountry: any = { id: 682, calling_code: '966', name: 'Saudi Arabia' };
	selectedCountryName: any = '';
	selectedCountryCode: string = '';
	isDropdownOpen: boolean = false;

	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	PhoneNumberFormat = PhoneNumberFormat;
	preferredCountries: CountryISO[] = [CountryISO.SaudiArabia, CountryISO.UnitedArabEmirates, CountryISO.Kuwait, CountryISO.Bahrain, CountryISO.UnitedStates, CountryISO.UnitedKingdom];
	input: any = '';
	guest_route: any;

	servicesFeatures = [
		{ displayName: i18n.signup.invoicing, value: 'invoicing' },
		{ displayName: i18n.signup.online_store, value: 'online_store' },
		{ displayName: i18n.signup.invoicing_online_store, value: 'invoicing_online_store' }
	];

	productsFeatures = [
		{ displayName: i18n.signup.invoicing, value: 'invoicing' },
		{ displayName: i18n.signup.online_store, value: 'online_store' },
		{ displayName: i18n.signup.food_beverage_ordering, value: 'food_beverage_ordering' },
		{ displayName: i18n.signup.invoicing_online_store, value: 'invoicing_online_store' }
	];
	private clickListener: () => void;

	constructor(
		private fb: FormBuilder,
		private renderer: Renderer2,
		private http: HttpClient,
		private router: Router,
		private loaderService: LoaderService,
		private countryService: CountryService,
		private dataLayerService: DataLayerService,
		private profileService: ProfileService,
		private customerAuthService: CustomerAuthService,
	) {
		this.signupForm = this.fb.group({
			email: ['', [Validators.required, Validators.email], [uniqueCustomerEmailValidator(this.profileService)]],
			password: ['', [Validators.required, Validators.minLength(6)]],
			first_name: ['', [Validators.required, Validators.minLength(3)]],
			last_name: ['', [Validators.required, Validators.minLength(3)]],
			// businessName: ['', [Validators.required, Validators.minLength(3)]],
			passwordConfirm: ['', [Validators.required]],
			country_id: [682, [Validators.required]],
			dob: ['', [Validators.required]],
			phone: ['', [Validators.required], [uniqueCustomerPhoneValidator(this.profileService)]],
		}, { validators: this.passwordMatchValidator });

		this.otpForm = this.fb.group({
			0: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
			3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
		});
	}

	ngOnInit(): void {
		this.isLangArabic();
		this.loadCountries();
		setTimeout(() => {
			$('select[nice-select]').niceSelect('update');
		}, 300);
	}

	ngAfterViewInit(): void {
		this.updateLeftStepHeight();

		const signupStepsRight = document.querySelector('.signup_steps_right') as HTMLElement;

		if (signupStepsRight) {
			this.clickListener = this.renderer.listen(signupStepsRight, 'click', () => {
				this.updateLeftStepHeight();
			});
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['step']) {
			this.updateLeftStepHeight();
		}
	}

	private updateLeftStepHeight(): void {
		const signupStepsRight = document.querySelector('.signup_steps_right') as HTMLElement;
		const signupStepsLeft = document.querySelectorAll('.signup_steps_left');

		if (signupStepsRight) {
			const rightHeight = signupStepsRight.clientHeight;
			signupStepsLeft.forEach((leftStep) => {
				this.renderer.setStyle(leftStep, 'height', `${rightHeight + 60}px`);
			});
		}
	}

	async loadCountries() {

		await this.countryService.signup().subscribe((data: any) => {
			this.countries = data;
			// this.countries.forEach(element => {
			//   // if (element.id == this.hyperpayPaymentForm?.hyperpay_info.bank?.id) {
			//   //   this.selectedBank = { 'id': this.hyperpayPaymentForm?.hyperpay_info.bank?.id, 'bank_name': element.bank_name };
			//   // }
			// });
			// this.cdr.detectChanges();
		});
	}

	// loadCountries(): void {
	//   this.countryService.all().subscribe(
	//     (data: any) => {
	//       this.countries = data;
	//     },
	//     (error) => {
	//       console.error('Error loading countries:', error);
	//     }
	//   );
	// }

	switchTab(tab: 'email' | 'phone'): void {
		this.currentTab = tab;
		if (tab === 'email') {
			this.signupForm.get('phone')?.reset();
		} else {
			this.signupForm.get('email')?.reset();
			this.signupForm.get('password')?.reset();
			this.signupForm.get('passwordConfirm')?.reset();
		}
	}

	isLangArabic(): void {
		this.langAttribute = document.documentElement.getAttribute('lang');
		console.log(this.langAttribute);
	}

	selectAccountType(type: string): void {
		this.accountType = type;
		this.signupForm.markAsDirty();
	}

	passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
		const password = control.get('password')?.value;
		const confirmPassword = control.get('passwordConfirm')?.value;
		if (password && confirmPassword && password !== confirmPassword) {
			control.get('passwordConfirm')?.setErrors({ mismatch: true });
			return { mismatch: true };
		}
		return null;
	}

	isFormValid(): boolean {
		return this.signupForm.get('email')?.valid && this.signupForm.get('password')?.valid && this.signupForm.get('passwordConfirm')?.valid && this.isTermsChecked;
	}

	isForm3Valid(): boolean {
		return this.signupForm.get('first_name')?.valid && this.signupForm.get('last_name')?.valid && this.signupForm.get('dob')?.valid;
	}

	isFormPhoneValid(): boolean {
		return this.signupForm.get('phone')?.valid && this.isTermsChecked;
	}

	toggleDropdown(): void {
		this.isDropdownOpen = !this.isDropdownOpen;
	}

	getCountryByFind(id) {
		return this.countries.find(x => x.id == id);
	}

	onChangeCountry(id) {
		this.selectedCountry = this.getCountryByFind(id);
	}

	selectCountry(country: { id: number; name: string }): void {
		this.selectedCountry = country.id;
		this.selectedCountryName = country.name;
		this.isDropdownOpen = false;
	}
	selectCountryCode(country: { calling_code: string }): void {
		this.selectedCountryCode = country.calling_code;
		this.isDropdownOpen = false;
	}

	selectBusinessType(type: string) {
		this.selectedBusinessType = type;
		this.selectedFeature = null;
	}

	selectFeature(feature: { displayName: string; value: string }): void {
		this.selectedFeature = feature.value;
	}

	get isForm4Valid(): boolean {
		if (this.selectedBusinessType && this.selectedFeature) {
			return true;
		}
		return false;
	}

	nextStep(): void {
		if (this.step == 1) {
			this.step++;
			this.updateLeftStepHeight()

			let fd;
			if (this.currentTab == 'email') {
				fd = {
					email: this.signupForm.get('email')?.value,
					password: this.signupForm.get('password')?.value,
					password_confirmation: this.signupForm.get('passwordConfirm')?.value,
				};
			} else {
				const phoneData = this.signupForm.get('phone')?.value;
				fd = {
					phone: this.cleanPhoneNumber(phoneData?.number),
					countrycode: phoneData?.countryCode,
					dialcode: phoneData?.dialCode
				};
				// fd = {
				//   phone: this.signupForm.get('phone')?.value,
				//   country_id: this.signupForm.get('country_id')?.value,
				// };
			}

			this.loaderService.startLoading();
			this.profileService.sendOtp(fd).subscribe((res: any) => {
				this.loaderService.stopLoading();
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), "error");
			});
		} else if (this.step === 2) {
			this.resendTimer = 0;

			const otp = Object.values(this.otpForm.value).join('');

			let fd;
			if (this.currentTab == 'email') {
				fd = { email: this.signupForm.get('email')?.value };
			} else {
				// fd = { phone: this.signupForm.get('phone')?.value };
				const phoneData = this.signupForm.get('phone')?.value;
				fd = {
					phone: this.cleanPhoneNumber(phoneData?.number),
					countrycode: phoneData?.countryCode,
					dialcode: phoneData?.dialCode
				};
			}

			fd.otp = otp;

			this.loaderService.startLoading();
			this.profileService.verifyOtp(fd).subscribe((res: any) => {
				this.loaderService.stopLoading();
				if (this.step < 3) {
					this.step++;
					this.updateLeftStepHeight()
				}
			}, err => {
				this.loaderService.stopLoading();
				Swal.fire(i18n.alert.error, i18n.getError(err), "error");
			});
		}

		this.updateLeftStepHeight()
	}

	previousStep(): void {
		if (this.step > 1) {
			this.step--;
			this.updateLeftStepHeight()
		}
	}

	toggleTermsChecked(): void {
		this.isTermsChecked = !this.isTermsChecked;
	}

	get otpControls(): FormControl[] {
		return Object.keys(this.otpForm.controls).map(
			key => this.otpForm.get(key) as FormControl
		);
	}

	focusNext(event: Event, index: number): void {
		const input = event.target as HTMLInputElement;
		if (input.value && index < this.otpControls.length - 1) {
			const nextInput = document.querySelectorAll<HTMLInputElement>('.otp-input')[index + 1];
			nextInput?.focus();
		}
	}

	startResendTimer(): void {
		this.resendDisabled = true;
		this.resendTimer = 30;
		if (this.interval) {
			clearInterval(this.interval);
		}
		this.interval = setInterval(() => {
			if (this.resendTimer > 0) {
				this.resendTimer--;
			} else {
				this.resendDisabled = false;
				clearInterval(this.interval);
			}
		}, 1000);
	}

	resendOTP(): void {
		this.startResendTimer();
		let fd;
		if (this.currentTab == 'email') {
			fd = { username: this.signupForm.get('email')?.value,signup : 1 };
		} else {
			// fd = { username: this.signupForm.get('phone')?.value };
			const phoneData = this.signupForm.get('phone')?.value;
			fd = {
				username: this.cleanPhoneNumber(phoneData?.number),
				countrycode: phoneData?.countryCode,
				dialcode: phoneData?.dialCode,
				signup : 1
			};
		}

		this.loaderService.startLoading();

		// setTimeout(() => {
		//   this.loaderService.stopLoading();
		// }, 300)
		this.profileService.resendOtp(fd).subscribe((res: any) => {
			this.loaderService.stopLoading();
		}, err => {
			this.loaderService.stopLoading();
			Swal.fire(i18n.alert.error, i18n.getError(err), "error");
		});
	}

	submitRegistration(): void {
		// if (this.signupForm.valid) {
		if (this.currentTab === 'email' && this.isForm3Valid()) {
			const registrationData = {
				// name: this.signupForm.get('name')?.value,
				email: this.signupForm.get('email')?.value,
				password: this.signupForm.get('password')?.value,
				phone: this.signupForm.get('phone').value,
				first_name: this.signupForm.get('first_name').value,
				last_name: this.signupForm.get('last_name').value,
				dob: this.signupForm.get('dob').value,
				// business_name: this.signupForm.get('businessName')?.value,
				country_id: this.signupForm.get('country_id')?.value,
				// business_type: this.selectedFeature,
				// store_type: this.selectedBusinessType,
			};

			this.sendRegistrationRequest(registrationData);
		} else if (this.currentTab === 'phone' && this.isForm3Valid()) {
			const phoneData = this.signupForm.get('phone')?.value;
			const registrationData = {
				// name: this.signupForm.get('name')?.value,
				phone: this.cleanPhoneNumber(phoneData?.number), // this.signupForm.get('phone')?.value,
				// business_name: this.signupForm.get('businessName')?.value,
				country_id: this.signupForm.get('country_id')?.value,
				// country_id: this.signupForm.get('countryCode')?.value || null,
				// business_type: this.selectedFeature,
				dob: this.signupForm.get('dob').value,
				store_type: this.selectedBusinessType,
				country_code: phoneData?.countryCode,
				first_name: this.signupForm.get('first_name').value,
				last_name: this.signupForm.get('last_name').value,
				dial_code: phoneData?.dialCode
			};

			this.sendRegistrationRequest(registrationData);
		} else {
			Swal.fire(i18n.alert.error, i18n.customer.error.all_field, "error");
		}
		// }    
	}

	private sendRegistrationRequest(data: any): void {
		let fd = data;// this.signupForm.value;
		this.loaderService.startLoading();
		this.profileService.singup(fd).subscribe((res: any) => {
			this.loaderService.stopLoading();
			this.customerAuthService.login();
			Swal.fire(i18n.alert.success, i18n.customer.signup.success, 'success');
			if (res.intended_url?.includes("checkout")) {
				window.location.href = res.intended_url;
			} else {
				window.location.reload();
			}
		}, err => {
			this.loaderService.stopLoading();
			Swal.fire(i18n.alert.error, i18n.getError(err), "error");
		});
	}

	cleanPhoneNumber(phone: string): string {
		return phone.replace(/\s+/g, '').replace(/^0+/, '');
	}

	authToggle(state: string) {
		this.authState.emit(state);
	}

	continueAsGuest() {
		this.guest_route = (window as any).guestRoute ? (window as any).guestRoute : null;
		window.location.href = this.guest_route;
	}

	openDatePicker(event: Event): void {
		this.input = event.target as HTMLInputElement;
		if (this.input.showPicker) {
			this.input.showPicker(); // Supported in Chrome
		}
	}

	togglePasswordVisibility(): void {
		this.showPassword = !this.showPassword;
	}
}

// end
